import { z } from 'zod';

export const AreaSchema = z.object({
  id: z.string().uuid(),
  project_id: z.string().uuid(),
  name: z.string(),
  level: z.string(),
  length: z.number().nullable(),
  width: z.number().nullable(),
  height: z.number().nullable(),
  area: z.number().nullable(),
  perimeter: z.number().nullable(),
  unit: z.string().default('m²'),
  notes: z.string().nullable(),
  source_drawing: z.string().nullable(),
  ai_extracted: z.boolean().default(true),
  overridden: z.boolean().default(false),
  area_group_id: z.string().uuid().nullable(),
  phase_id: z.string().uuid().nullable(),
  sort_order: z.number().int().default(0),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateAreaSchema = z.object({
  name: z.string().min(1, 'Area name is required'),
  level: z.string().optional().default('Ground Floor'),
  length: z.number().optional(),
  width: z.number().optional(),
  height: z.number().optional(),
  area: z.number().optional(),
  perimeter: z.number().optional(),
  unit: z.string().optional().default('m²'),
  notes: z.string().optional(),
  source_drawing: z.string().optional(),
});

export const UpdateAreaSchema = z.object({
  name: z.string().min(1).optional(),
  level: z.string().optional(),
  length: z.number().nullable().optional(),
  width: z.number().nullable().optional(),
  height: z.number().nullable().optional(),
  area: z.number().nullable().optional(),
  perimeter: z.number().nullable().optional(),
  unit: z.string().optional(),
  notes: z.string().nullable().optional(),
  source_drawing: z.string().nullable().optional(),
  overridden: z.boolean().optional(),
  area_group_id: z.string().uuid().nullable().optional(),
  phase_id: z.string().uuid().nullable().optional(),
  sort_order: z.number().int().optional(),
});

export type Area = z.infer<typeof AreaSchema>;
export type CreateArea = z.input<typeof CreateAreaSchema>;
export type UpdateArea = z.infer<typeof UpdateAreaSchema>;
